import React from 'react';
import { Heart, Activity, ShieldCheck } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const GynecologyPage = () => {
  const config = {
    badge: "Gynecology & Obstetrics",
    headline: "Reproductive",
    headlineItalic: "Excellence.",
    subtext: "Compassionate and clinically advanced reproductive healthcare for your pet, from whelping support to complex gynecological surgery.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Veterinary Gynecology at Dr. Suresh Pet Care — Reproductive Health Excellence",
    stats: [
      { value: 1200, suffix: '+', label: 'Successful Deliveries' },
      { value: 98, suffix: '%', label: 'Maternal Safety Rate' },
      { value: 7, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Whelping' },
    ],
    services: [
      {
        title: "Reproductive Diagnostics",
        icon: <Activity size={28} />,
        desc: "Advanced progesterone testing, vaginal cytology, and ultrasound for breeding timing and pregnancy confirmation.",
        specs: ["Progesterone Testing", "Vaginal Cytology", "Pregnancy Ultrasound", "Litter Count"],
        color: "from-pink-500/10 to-primary/10"
      },
      {
        title: "Whelping Support",
        icon: <Heart size={28} />,
        desc: "Round-the-clock whelping supervision, oxytocin protocols, and emergency C-section capabilities.",
        specs: ["Labour Monitoring", "Emergency C-Section", "Puppy Resuscitation", "Post-Partum Care"],
        color: "from-primary/10 to-rose-500/10"
      },
      {
        title: "Gynecological Surgery",
        icon: <ShieldCheck size={28} />,
        desc: "Treatment of pyometra, ovarian cysts, and complex uterine conditions requiring surgical intervention.",
        specs: ["Pyometra Surgery", "Ovarian Cysts", "Cesarean Section", "Uterine Disorders"],
        color: "from-red-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Reproductive",
    sectionItalic: "Services.",
    warningTitle: "Reproductive",
    warningItalic: "Warning Signs.",
    warningText: "Recognizing early reproductive health issues is critical to your pet's wellbeing. Prompt intervention prevents life-threatening conditions.",
    warnings: [
      { name: "Vaginal Discharge", desc: "Unusual discharge can signal pyometra, infection, or early-stage reproductive disease.", icon: "⚠️" },
      { name: "Prolonged Labour", desc: "Straining for over an hour without delivery requires immediate emergency attention.", icon: "⏱️" },
      { name: "Abdominal Distension", desc: "Sudden swelling may indicate pyometra, pregnancy complications, or cysts.", icon: "🩺" },
      { name: "Excessive Lethargy in Pregnancy", desc: "Unusual tiredness during gestation can signal gestational complications.", icon: "😴" },
    ],
    ctaBadge: "Reproductive Medicine",
    ctaTitle: "The Gynecology",
    ctaItalic: "Expertise.",
    ctaText: "Dr. T Suresh Babu leads a dedicated obstetric and gynecology unit ensuring safe deliveries and expert reproductive surgical care in Hyderabad.",
    ctaBtn: "Book Reproductive Consult",
    seoText: "Expert veterinary gynecology and obstetrics in Hyderabad. Whelping support, C-sections, and pyometra treatment at Dr. Suresh Pet Care.",
    glowColor: "pink-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary Gynecology & Obstetrics"
        description="Expert reproductive healthcare, whelping support, and gynecological surgery for pets at Dr. Suresh Pet Care in Hyderabad."
        canonical="/gynecology"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default GynecologyPage;
